import React from "react";
import { formatarPreco } from "../../utils/preco";

const Preco = ({ valor, className = "" }) => (
  <span className={`gm-preco ${className}`.trim()}>{formatarPreco(valor)}</span>
);

export default Preco;
